import { temAcesso } from '@/shared/auth/temAcesso'

const Feriados = () => import('./Feriados.vue')
const FeriadoForm = () => import('./FeriadoForm.vue')
const FeriadoDetalhar = () => import('./FeriadoDetalhar.vue')

export default {
    path: 'feriados',
    name: 'Feriados',
    component: Feriados,
    beforeEnter: (to, from, next) => {
        if (temAcesso('ADMIN-FERIADOS-00')) {
            next()
        }
    },
    children: [
        {
            path: 'inserir',
            name: 'Feriado_Inserir',
            component: FeriadoForm,
            beforeEnter: (to, from, next) => {
                if (temAcesso('ADMIN-FERIADOS-01')) {
                    next()
                }
            }
        },
        {
            path: ':feriadoId',
            name: 'Feriado_Detalhar',
            component: FeriadoDetalhar,
            beforeEnter: (to, from, next) => {
                if (temAcesso('ADMIN-FERIADOS-02')) {
                    next()
                }
            }
        },
        {
            path: ':feriadoId/atualizar',
            name: 'Feriado_Atualizar',
            component: FeriadoForm,
            beforeEnter: (to, from, next) => {
                if (temAcesso('ADMIN-FERIADOS-03')) {
                    next()
                }
            }
        }
    ]
}
